import { render, staticRenderFns } from "./marquee-gallery.vue?vue&type=template&id=4429dafa&"
import script from "./marquee-gallery.vue?vue&type=script&lang=js&"
export * from "./marquee-gallery.vue?vue&type=script&lang=js&"
import style0 from "./marquee-gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4429dafa')) {
      api.createRecord('4429dafa', component.options)
    } else {
      api.reload('4429dafa', component.options)
    }
    module.hot.accept("./marquee-gallery.vue?vue&type=template&id=4429dafa&", function () {
      api.rerender('4429dafa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/marquee-gallery.vue"
export default component.exports